export const API_URL = process.env.REACT_APP_API_URL ?? ''

export const ALCHEMY_API_KEY =
  (process.env.ALCHEMY_API_KEY || process.env.REACT_APP_ALCHEMY_API_KEY) ??
  'YuxRvMDRHZIFjn1-2EdAQ9smB1sPDAYf'
